import { Box, DialogContent, DialogTitle, Stack } from "@mui/material";
import { employeeBussiness } from "api/bussiness/employee/employee-bussiness";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { observer } from "mobx-react-lite";
import { IAddEmployee } from "mobx-stores/_models/employee/employee";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useState } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { XAvatar } from "share-components/x-avatar/x-avatar";
import { employeeFormSchema } from "../schema";

export const AddEmployee = observer(() => {
  const {
    employeeManagement: { openNew, setProp, getEmployees },
  } = useStores();
  const [imageSource, setImageSource] = useState<File | null>(null);

  const {
    form: { controls, isValid },
    submitHandler,
  } = useForm<IAddEmployee>(employeeFormSchema(), {
    code: "",
    fullName: "",
    branch: "",
    departmentTypeId: "",
    gender: null,
    level: "",
    note: "",
    position: "",
    qualification: "",
  });

  const saveHandler = useCallback(
    async (data: IAddEmployee) => {
      await employeeBussiness.addEmployeeAsForm(data, imageSource);
      await getEmployees();
      setProp("openNew", false);
    },
    [getEmployees, imageSource, setProp]
  );

  const handleChangeSource = (selectedFile: File) => {
    setImageSource(selectedFile);
  };

  return (
    <DialogForm
      open={openNew}
      fullWidth
      maxWidth={"md"}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => {
        submitHandler(saveHandler);
      }}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm nhân viên</DialogTitle>
      <DialogContent>
        <Stack direction={"row"} justifyContent={"center"}>
          <XAvatar
            src={imageSource || ""}
            alt="Avatar"
            onChange={handleChangeSource}
          />
        </Stack>
        <Box sx={{ marginTop: "15px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
